// web/src/billing/PaywallModal.tsx
//
// Generic upgrade modal for any Pro feature. Today wired only by
// AskTapelensButton, but designed to be reused for any future Pro
// gate (premium analyses, advanced alerts, etc.).
import { Button } from "@/components/ui/button";
import {
  Dialog, DialogContent, DialogDescription, DialogFooter,
  DialogHeader, DialogTitle,
} from "@/components/ui/dialog";
import { Check } from "lucide-react";


interface Props {
  open: boolean;
  onClose: () => void;
  title: string;
  description?: string;
  bullets: string[];
}


export function PaywallModal({ open, onClose, title, description, bullets }: Props) {
  return (
    <Dialog open={open} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          {description && <DialogDescription>{description}</DialogDescription>}
        </DialogHeader>
        {bullets.length > 0 && (
          <ul className="space-y-2 text-sm">
            {bullets.map((b) => (
              <li key={b} className="flex items-start gap-2">
                <Check className="size-4 mt-0.5 shrink-0 text-emerald-600" />
                <span>{b}</span>
              </li>
            ))}
          </ul>
        )}
        <DialogFooter className="flex-col sm:flex-row gap-2">
          <Button variant="ghost" onClick={onClose}>Maybe later</Button>
          <Button asChild>
            <a href="https://tapelens.com/pricing" onClick={onClose}>Start free 14-day trial</a>
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
